import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import { ReactComponent as IconFilter } from "../../../assets/Icon-Filter.svg";

const useStyle = makeStyles((theme) => ({
  filterButton: {
    backgroundColor: "transparent",
    borderRadius: "8px",
    color: theme.palette.text.secondary,
    width: "93px",
    height: "40px",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#F2F2F2",
      width: "93px",
      height: "40px",
      color: theme.palette.text.primary,
      transform: "none",
    },
  },
  filterButtonActive: {
    backgroundColor: "#F2F2F2",
    width: "93px",
    height: "40px",
    color: theme.palette.text.primary,
    transform: "none",
    borderRadius: "8px",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#F2F2F2",
      width: "93px",
      height: "40px",
      color: theme.palette.text.primary,
      transform: "none",
    },
  },
  filterButtonIcon: {
    width: "16px",
    height: "16px",
  },
  filterButtonTextIcon: {
    width: "18px",
    height: "18px",
  },
}));

interface filterButtonProps {
  handleOpen: () => void;
  filterCount: number;
}
export const FilterButton = (props: filterButtonProps) => {
  const classes = useStyle();
  const { handleOpen, filterCount } = props;
  return (
    <Button
      onClick={handleOpen}
      size="medium"
      className={filterCount > 0 ? classes.filterButtonActive : classes.filterButton}
      variant="contained"
      endIcon={
        filterCount > 0 ? (
          <Box
            sx={{ borderRadius: "50%", backgroundColor: "#000000" }}
            className={classes.filterButtonTextIcon}>
            <Typography
              sx={{
                color: "#ffffff",
                fontSize: "0.6em",
                fontWeight: "600",
              }}>
              {filterCount}
            </Typography>
          </Box>
        ) : (
          <IconFilter className={classes.filterButtonIcon} />
        )
      }>
      Filter
    </Button>
  );
};
